export default __webpack_public_path__ + "static/media/warning.5f0a77c8.svg";